import { Service } from "../shared/Service";

export class CriterioService extends Service{

  constructor(){
    super('criterio');
  }

}